<template>
  <sc-modal :active="this.showModal" @close="handleClose">
    <sc-modal-card class="config-modal-card" :title="title">
      <template class="body" slot="body">
        <form @submit.prevent="onSubmitInstallation">

          <app-config-form :schemaBased="schemaBased" ref="appConfigForm"/>

          <sc-button
            class="is-fullwidth"
            theme="primary"
            :text="formSaveButton"
            :disabled="loading"
            @click="() => onSubmitInstallation()"
          />
        </form>
      </template>
    </sc-modal-card>
  </sc-modal>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScButton,
  ScField,
  ScModal,
  ScInput,
  ScTaginput,
  ScModalCard,
  ScToast,
} from "@intelipost-js/secure-components";
import AppConfigForm from "../components/AppConfigForm.vue";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal-config",

  data() {
    return {
      title: "Configurando a instalação",
      showModal: false,
      schemaBased: {
        fields: []
      },
    };
  },

  computed: {
    ...mapState([
      "loading",
      "showConfigModal",
      "selectedApp",
      "appConfigUpdated",
    ]),

    formSaveButton() {
      return "Instalar";
    },
  },

  methods: {
    ...mapActions([
      "getAppList",
      "saveIntegrationConfigs",
      "installAppAction",
      "showConfigModalAction",
      "selectAppAction",
      "updateAppConfig",
      "clearAppNameFilterField",
    ]),

    handleClose() {
      this.showConfigModalAction(false);
    },

    onSubmitInstallation() {
      if (!this.$refs.appConfigForm.validate()) {
        return ScToast.danger("Revise os campos preenchidos");
      }

      const app = {
        app_id: this.selectedApp.id,
        app_config: JSON.parse(JSON.stringify(this.appConfigUpdated)),
      };

      this.installAppAction(app).then(({ ok, message }) => {
        if (ok) {
          this.getAppList();
          this.handleClose();
          this.updateAppConfig(null);
          this.clearAppNameFilterField();
          return ScToast.success("Aplicativo instalado com sucesso");
        }

        return ScToast.open({message, duration: 20000, type: 'is-danger'});
      });
    },
  },

  mounted() {
    this.showModal = this.showConfigModal;
    this.updateAppConfig({});

    if (this.selectedApp && this.selectedApp.schemaBased) {
      this.schemaBased =  JSON.parse(this.selectedApp.schemaBased);
    }
  },

  components: {
    ScButton,
    ScField,
    ScInput,
    ScTaginput,
    ScModal,
    ScModalCard,
    ScToast,
    'app-config-form': AppConfigForm,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

@media screen and (max-width: 768px) {
  .config-modal-card {
    width: 100%;
  }
}

@media screen and (min-width: 769px) {
  .config-modal-card {
    width: 750px;
  }
}

@media screen and (min-width: 1000px) {
  .config-modal-card {
    width: 950px;
  }
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/config/ModalConfig.vue